import React, { useState, useEffect, useContext } from "react";
import { Link } from "react-router-dom";
import Dialog from "@mui/material/Dialog";
import { makeStyles } from "@mui/styles";
import { Button, IconButton } from "@mui/material";
import { useNavigate } from "react-router";

import bagIcon from "../../../../../assets/img/icons/bag.png";
import discountIcon from "../../../../../assets/img/icons/discount.png";
import extraIcon from "../../../../../assets/img/icons/extra.png";
import homeIcon from "../../../../../assets/img/icons/home.png";

import AddIcon from "@mui/icons-material/Add";
import "./styles/styles.scss";

const Footer = (props) => {
  const navigate = useNavigate();
  const handle_navigateToAddProduct = (e) => {
    navigate("/add-product");
  };

  return (
    <>
      <footer className="main_footer m-0 p-0  d-flex flex-column justify-content-between align-items-stretch">
        <div className="footer-holder m-0 p-0 ">
          <div
            style={{
              cursor: "pointer",
            }}
            onClick={handle_navigateToAddProduct}
            className="m-0 p-0 d-flex flex-row justify-content-center align-items-center"
          >
            <Button
              className="courses-btn"
              variant="contained"
              color="primary4"
            >
              <AddIcon fontSize="large" />
            </Button>
          </div>
          <div className="footer-down d-flex flex-row justify-content-between align-items-center">
            <div className="nav-right ps-3 col-4 d-flex flex-row justify-content-between align-items-center">
              <Link to="/" className="text-decoration-none ">
                <img className="" alt="..." src={homeIcon} />
              </Link>
              <Link to="/bargaining" className="text-decoration-none ">
                <img className="" alt="..." src={discountIcon} />
              </Link>
            </div>
            <div className="nav-left pe-3 col-4 d-flex flex-row justify-content-between align-items-center">
              <Link to="/products" className="text-decoration-none ">
                <img className="" alt="..." src={extraIcon} />
              </Link>
              <Link to="/orders" className="text-decoration-none ">
                <img className="" alt="..." src={bagIcon} />
              </Link>
            </div>
          </div>
        </div>
      </footer>
      <div className="footer-placeholder">
        this is footer's placeholder . don't touch it !
      </div>
    </>
  );
};

export default Footer;
